
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useAuthState } from '../../../../../../Helper/Context';
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL';
import { LocationDDL } from '../../../../../../Components/CommonDDL/LocationDDL';
import { PillerDDL } from '../../../../../../Components/CommonDDL/PillerDDL';
import { Get_M_ELEC_Piller_Wise_PoleCount_SelectDataAPI, PoleEleMasterPostDataAPI, PoleEleMasterTableDataAPI } from '../../../../../../Redux/ElectricalSlice/PoleSlice';
import { Pegination } from '../../../../../../Components/Pegination/Pegination';
import { PoleDDL } from '../../../../../../Components/CommonDDL/PoleDDL';
import { Loading } from '../../../../../../Helper/Loading';
import SingleMapView from '../../../../../../Components/MapView/SingleMapView';


export default function PoleCounrPopUp(props) {

    const { rowData, open, handleOnCloseClick, WardName, LocationName } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch();

    const [IsPost, setIsPost] = useState(false)
    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [LocationData, setLocationData] = React.useState({})
    const [ShowMap, setShowMap] = React.useState(false)

    const [PillerID, setPillerID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [PoleID, setPoleID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })


    const handleClear = () => {
        setPillerID({
            ...PillerID,
            ID: 0,
            Label: 'Select...',
        })
        setPoleID({
            ...PoleID,
            ID: 0,
            Label: 'Select...',
        })
    }

    useEffect(() => {
        const data = {
            M_WardID: rowData?.m_WardID,
            M_ELEC_PillerID: PillerID?.ID == 0 ? rowData?.m_eleC_PillerID : PillerID?.ID,
            M_ELEC_LocationID: rowData?.m_eleC_LocationID,
            M_UserID: UserID,
            Flag: 'WardWisePole',
            token: token,
            From: From,
            To: To,
        }
        dispatch(PoleEleMasterTableDataAPI({ data }))
    }, [rowData, PillerID?.ID, To])

    const { tableData, isLoading } = useSelector(state => state.PoleEleMasterTableData)

    const handleOpenMapClick = (item) => {
        if (item.latitude && item.longitude) {
            setShowMap(true)
            setLocationData({
                latitude: item.latitude,
                longitude: item.longitude,
                data: item
            })
        }
    }


    const handleCloseMap = () => {
        setShowMap(false)
    }

    return (


        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
            contentStyle={{ width: '90vw' }}
        >
            <div className="modal-dialog modal-dialog-scrollable modal-xl" >
                <div className="modal-content master_border">
                    <div className="modal-header pl-4 p-1">
                        <h5 className="modal-title pt-1" id="staticBackdropLabel">
                            Ward Wise Pillers and Poles
                        </h5>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>
                    {isLoading && <Loading />}
                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className="row details-row col-12 ">
                                <div className="col-12 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                    <div className="col-12">

                                        {/* <div className="row py-1 rounded2">


                                            <div className="col-12 col-md-4 col-lg-4">
                                                <PillerDDL
                                                    PillerID={PillerID}
                                                    setPillerID={setPillerID}
                                                    WardName={WardName}
                                                    LocationName={LocationName}
                                                    APIFlag="Master"
                                                    IsPost={IsPost}
                                                />
                                            </div>

                                            <div className="col-12 col-md-4 col-lg-4">
                                                <PoleDDL
                                                    PoleID={PoleID}
                                                    setPoleID={setPoleID}
                                                    WardName={WardName}
                                                    LocationName={LocationName}
                                                    PillerID={PillerID}
                                                    APIFlag="Master"
                                                    IsPost={IsPost}
                                                />
                                            </div>

                                            <div className="col-12 col-md-3 col-lg-2 mt-4">
                                               
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>
                                            </div>
                                        </div> */}

                                        <div className="row mob_table table-responsive pt-1">

                                            <table
                                                id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Ward Name</th>
                                                        <th>Location</th>
                                                        <th>Piller No</th>
                                                        <th>Pole No</th>
                                                        {/* <th>Piller Count</th> */}
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((i) =>
                                                            <tr style={{ width: '100%' }}>
                                                                <td style={{ textAlign: "center" }}>{i?.rowNum}</td>
                                                                <td>{i?.wardName}</td>
                                                                <td>{i?.locationName}</td>
                                                                <td style={{ textAlign: 'center' }}>{i?.pillerNo}</td>
                                                                <td style={{ textAlign: 'center' }}>
                                                                    {i?.poleNumber}
                                                                </td>
                                                                {/* <td></td> */}
                                                                <td style={{ textAlign: "center", width: '7%' }}>

                                                                    <span>
                                                                        {
                                                                            (i?.latitude != null && i?.longitude != null) && (i?.latitude != "null" && i?.longitude != "null") ?
                                                                                <i className="fas fa-map-marked-alt" title='View Map'
                                                                                    style={{ cursor: 'pointer', color: 'green', fontSize: '18px' }}
                                                                                    onClick={() => handleOpenMapClick(i)}
                                                                                >
                                                                                </i>
                                                                                :
                                                                                '-'
                                                                        }
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ) :
                                                            <td colSpan={15}>No data found</td>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFrom}
                                                setTo={setTo}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {
                ShowMap ?
                    <SingleMapView
                        LoactionData={LocationData}
                        ShowMap={ShowMap}
                        handleCloseMap={handleCloseMap}
                        currEmployeeName=''
                    />
                    : ''
            }


        </Popup>
    )

}